import React from 'react';
import { Box, Paper, Typography, IconButton } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { withRouter, useHistory } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import RegistrationReceivedActions from '../../redux/reducers/registration_received_reducer/actions';
import useStyles from './styles';
import clsx from 'clsx';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import { TableDefaultFetchValues, Translations } from './configuration';
import FixedEstablishmentsReceived from './components/fixed_establishments_received';
import RegistrationReceivedInfo from './components/registration_received_info';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NavigationConfig from '../../navigation/config';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';
interface IProps {}

const RegistrationReceivedDetailPage = (props: IProps) => {
  // console.log('Render RegistrationReceivedDetailPage');
  const { id } = (props as any).match.params;

  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const state = getState(ReducerKeys.REGISTRATION_RECEIVED_REDUCER)
    .RegistrationReceivedList.data;
  // console.log('---------->', state);
  let queryString = state ? `?goBack=true${state.queryString}` : '?goBack=true';

  React.useEffect(() => {
    dispatch(
      RegistrationReceivedActions.fetchFEReceivedByRegistrationReceivedId({
        sortField: TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize: TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order: TableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        id,
      })
    );
    dispatch(
      RegistrationReceivedActions.viewRegistrationReceivedAction({
        registration_received_id: id,
      })
    );
  }, [dispatch]);

  return (
    <div>
      <Paper
        className={clsx(classes.cardLayout, classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        <Box display="flex" alignItems={'center'}>
          <IconButton
            onClick={() =>
              history.push(
                NavigationConfig.registrationReceivedPage().path + queryString
              )
            }
            aria-label="delete"
            className={classes.back_button}
          >
            <ArrowBackIcon />
          </IconButton>
          <AssignmentOutlinedIcon style={{ marginRight: '.75rem' }} />
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText textMap={Translations.page_title(id)} />
          </Typography>
        </Box>
      </Paper>
      <div style={{ padding: 12 }}>
        <RegistrationReceivedInfo />
        <FixedEstablishmentsReceived registration_received_id={id} />
      </div>
    </div>
  );
};

export default withRouter(RegistrationReceivedDetailPage);
